import { useEffect } from "react";

const SITE = "itzPlay";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export function usePageMeta({ title, description, noindex = false }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : "itzPlay - Spielen, Punkte sammeln, Prämien einlösen";
    const url = `${process.env.REACT_APP_SITE_URL}${window.location.pathname}`;
    document.title = full;
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    setMeta("property", "og:url", url);
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); setMeta("name", "twitter:description", description); }
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
  }, [title, description, noindex]);
}
